(function () {
  'use strict';
  if (window.WOVehicleCart) return;
  var PARAM = 'wo_vehicle';
  var MAX_CONTEXT_LENGTH = 12000;
  var SELECTED_KEY = 'wo-fitment:selected-vehicle:v1';
  var KEYS = ['year', 'make', 'model', 'modification'];
  var FORM_SELECTOR = 'form[data-wo-vehicle-form], [data-wo-vehicle-product] form';
  var PROPERTY_NAMES = ['Vehicle', '_Vehicle ID', 'Axle'];
  var formStates = new WeakMap();
  var pinned = false, context = null, observerQueued = false;

  function text(value) {
    return typeof value === 'string' && value.trim().length > 0 && value.length <= 240 &&
      !/[\u0000-\u001f\u007f]/.test(value) ? value.trim() : null;
  }
  function normalize(detail) {
    if (!detail || typeof detail !== 'object' || !detail.vehicle || !detail.labels) return null;
    var vehicle = {}, labels = {};
    for (var i = 0; i < KEYS.length; i++) {
      var key = KEYS[i], value = detail.vehicle[key];
      if (typeof value !== 'string' && !(key === 'year' && typeof value === 'number')) return null;
      value = String(value);
      if (key === 'year') {
        if (!/^\d{4}$/.test(value) || Number(value) < 1950 || Number(value) > new Date().getFullYear() + 1) return null;
      } else {
        if (!/^[a-z0-9][a-z0-9_-]{0,239}$/i.test(value)) return null;
        value = value.toLowerCase();
      }
      var label = text(detail.labels[key]);
      if (!label || (key === 'year' && label !== value)) return null;
      vehicle[key] = value;
      labels[key] = label;
    }
    return { vehicle: vehicle, labels: labels };
  }
  function encodedWithinLimit(value) {
    try { return value.length <= MAX_CONTEXT_LENGTH && encodeURIComponent(value).length <= MAX_CONTEXT_LENGTH; }
    catch (_) { return false; }
  }
  function normalizeAxleOptions(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).length !== 2) return null;
    var result = {};
    for (var i = 0; i < 2; i++) {
      var axle = i === 0 ? 'front' : 'rear';
      if (!Object.prototype.hasOwnProperty.call(value, axle) || !Array.isArray(value[axle])) return null;
      var values = [], seen = new Set();
      for (var j = 0; j < value[axle].length; j++) {
        var id = value[axle][j];
        if (typeof id !== 'string' || !/^[1-9]\d{0,29}$/.test(id)) return null;
        if (!seen.has(id)) { seen.add(id); values.push(id); }
        if (values.length > 250) return null;
      }
      result[axle] = values;
    }
    return result;
  }
  function axleContext(value, url) {
    if (!value || !['front', 'rear'].includes(value.axle) || typeof value.variantId !== 'string' || !/^[1-9]\d{0,29}$/.test(value.variantId)) return null;
    if (!url || url.searchParams.getAll('variant').length !== 1 || url.searchParams.get('variant') !== value.variantId) return null;
    var result = { axle: value.axle, variantId: value.variantId };
    if (Object.prototype.hasOwnProperty.call(value, 'axleOptions')) {
      var options = normalizeAxleOptions(value.axleOptions);
      if (!options || !options[value.axle].includes(value.variantId)) return null;
      result.axleOptions = options;
    }
    return result;
  }
  function readUrl() {
    var url;
    try { url = new URL(window.location.href); } catch (_) { return { explicit: true, value: null }; }
    if (url.searchParams.has(PARAM)) {
      var values = url.searchParams.getAll(PARAM);
      if (values.length !== 1 || !encodedWithinLimit(values[0])) return { explicit: true, value: null };
      try {
        var detail = JSON.parse(values[0]);
        var normalized = detail.v === 1 ? normalize(detail) : null;
        if (normalized) {
          normalized.purchase = axleContext(detail, url);
          if (Object.prototype.hasOwnProperty.call(detail, 'axleOptions') && !normalized.purchase) normalized = null;
        }
        return { explicit: true, value: normalized };
      } catch (_) { return { explicit: true, value: null }; }
    }
    var legacy = KEYS.concat('trim').some(function (key) { return url.searchParams.has(key); });
    return { explicit: legacy, value: null };
  }
  function readSaved() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(SELECTED_KEY) || 'null');
      if (!saved || typeof saved !== 'object') return null;
      var detail = { vehicle: {}, labels: {} };
      for (var i = 0; i < KEYS.length; i++) {
        var key = KEYS[i];
        if (!saved[key] || typeof saved[key] !== 'object') return null;
        detail.vehicle[key] = saved[key].value;
        detail.labels[key] = saved[key].label;
      }
      return normalize(detail);
    } catch (_) { return null; }
  }
  function pin() {
    if (pinned) return;
    pinned = true;
    var explicit = readUrl();
    context = explicit.explicit ? explicit.value : readSaved();
  }
  function purchaseOptions() {
    pin();
    if (!context || !context.purchase) return null;
    var purchase = context.purchase, copy = { axle: purchase.axle, variantId: purchase.variantId };
    if (purchase.axleOptions) copy.axleOptions = Object.freeze({
      front: Object.freeze(purchase.axleOptions.front.slice()),
      rear: Object.freeze(purchase.axleOptions.rear.slice())
    });
    return Object.freeze(copy);
  }
  function linkedAxle(variantId) {
    if (!context || !context.purchase || String(variantId) !== context.purchase.variantId) return null;
    return context.purchase.axle === 'front' ? 'Front' : 'Rear';
  }
  function formVariant(form) {
    var ids = Array.from(form.elements).filter(function (input) { return input.name === 'id'; });
    return ids.length === 1 ? ids[0].value : null;
  }
  function properties(form, variantId) {
    if (form) {
      bind(form);
      var result = {};
      new FormData(form).forEach(function (value, name) {
        var match = /^properties\[([^\]]+)\]$/.exec(name);
        if (match && typeof value === 'string') result[match[1]] = value;
      });
      if (variantId !== undefined) {
        delete result.Axle;
        var axle = linkedAxle(variantId);
        var expected = properties();
        if (axle && result.Vehicle === expected.Vehicle && result['_Vehicle ID'] === expected['_Vehicle ID']) result.Axle = axle;
      }
      return result;
    }
    if (!pinned || !context) return {};
    return {
      Vehicle: context.labels.year + ' ' + context.labels.make + ' ' + context.labels.model + ' · ' + context.labels.modification,
      '_Vehicle ID': KEYS.map(function (key) { return context.vehicle[key]; }).join('/')
    };
  }
  function productUrl(value, detail, purchase) {
    var normalized = normalize(detail), url;
    if (!normalized) return null;
    try { url = new URL(value, window.location.href); } catch (_) { return null; }
    if (url.protocol !== 'https:' || !['www.wheelsoutlet.com', 'wheelsoutlet.com'].includes(url.hostname.toLowerCase()) ||
        url.username || url.password || !/^\/products\/[a-z0-9]+(?:-[a-z0-9]+)*\/?$/i.test(url.pathname)) return null;
    var payload = { v: 1, vehicle: normalized.vehicle, labels: normalized.labels };
    if (purchase !== undefined) {
      var axle = axleContext(purchase, url);
      if (!axle) return null;
      payload.axle = axle.axle; payload.variantId = axle.variantId;
      if (axle.axleOptions) payload.axleOptions = axle.axleOptions;
    }
    var encoded = JSON.stringify(payload);
    if (!encodedWithinLimit(encoded)) return null;
    url.searchParams.set(PARAM, encoded);
    return url.href;
  }
  function wheelForm(form) {
    if (!form || form.tagName !== 'FORM' || !form.matches(FORM_SELECTOR)) return false;
    try {
      var action = new URL(form.action, window.location.href);
      return action.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(action.pathname);
    } catch (_) { return false; }
  }
  function stateFor(form) {
    var state = formStates.get(form);
    if (state) return state;
    state = { quantityInitialized: false, quantityTouched: false, settingQuantity: false };
    formStates.set(form, state);
    function changed(event) {
      if (event.target.name === 'quantity' && !state.settingQuantity) state.quantityTouched = true;
      if (event.target.name !== 'quantity') queueMicrotask(function () { bind(form); });
    }
    form.addEventListener('input', changed);
    form.addEventListener('change', changed);
    return state;
  }
  function bind(form) {
    if (!wheelForm(form)) return;
    pin();
    var state = stateFor(form), values = properties();
    var axle = linkedAxle(formVariant(form));
    if (axle) values.Axle = axle;
    var vehicleOverride = Array.from(form.elements).some(function (input) {
      return input.name === 'properties[Vehicle]' && input.dataset.woVehicleProperty !== 'true';
    });
    if (vehicleOverride) { delete values['_Vehicle ID']; delete values.Axle; }
    PROPERTY_NAMES.forEach(function (key) {
      var name = 'properties[' + key + ']';
      var existing = Array.from(form.elements).filter(function (input) { return input.name === name; });
      if (existing.some(function (input) { return input.dataset.woVehicleProperty !== 'true'; })) return;
      var input = existing[0];
      if (!values[key]) {
        existing.forEach(function (node) { node.remove(); });
        return;
      }
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden'; input.name = name;
        input.dataset.woVehicleProperty = 'true'; form.appendChild(input);
      }
      input.value = values[key];
      existing.slice(1).forEach(function (node) { node.remove(); });
    });
    if (values.Axle && !state.quantityInitialized && !state.quantityTouched) {
      var quantities = Array.from(form.elements).filter(function (input) { return input.name === 'quantity'; });
      if (quantities.length === 1) {
        state.quantityInitialized = true; state.settingQuantity = true;
        quantities[0].value = '2';
        quantities[0].dispatchEvent(new Event('change', { bubbles: true }));
        state.settingQuantity = false;
      }
    }
    var property = Array.from(form.elements).find(function (input) { return input.name === 'properties[Vehicle]'; });
    var summary = form.querySelector('[data-wo-vehicle-summary]');
    if (!property || !property.value.trim()) {
      if (summary) summary.remove();
    } else {
      if (!summary) {
        summary = document.createElement('p'); summary.className = 'wo-vehicle-purchase-summary';
        summary.setAttribute('data-wo-vehicle-summary', ''); form.insertBefore(summary, form.firstChild);
      }
      var axleProperty = Array.from(form.elements).find(function (input) { return input.name === 'properties[Axle]'; });
      var summaryText = 'Vehicle: ' + property.value + (axleProperty && axleProperty.value ? ' · ' + axleProperty.value + ' axle' : '');
      if (summary.textContent !== summaryText) summary.textContent = summaryText;
    }
  }
  function attach(root) {
    root = root || document;
    if (root.matches && root.matches(FORM_SELECTOR)) bind(root);
    if (root.querySelectorAll) root.querySelectorAll(FORM_SELECTOR).forEach(bind);
  }
  window.WOVehicleCart = Object.freeze({ productUrl: productUrl, purchaseOptions: purchaseOptions, properties: properties, attach: attach });
  document.addEventListener('wo:vehicle-reset', function () {
    try { sessionStorage.removeItem(SELECTED_KEY); } catch (_) {}
    context = null; pinned = true; attach();
  });
  document.addEventListener('submit', function (event) { bind(event.target); }, true);
  document.addEventListener('shopify:section:load', function (event) { attach(event.target); });
  function start() {
    attach();
    if (!document.body) return;
    new MutationObserver(function (records) {
      if (observerQueued || !records.some(function (record) { return record.addedNodes.length; })) return;
      observerQueued = true;
      queueMicrotask(function () { observerQueued = false; attach(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
